
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|1994|4830|9736)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
